import {
    ExpandButton,
    ExpandingLinks,
    ExpansionPanel,
    FundingLogo,
    HomeLink,
    InstitutionsHideShow,
    MobilePageNav,
    TitleContainer,
    TitleRow,
    TopLevelNavBox,
} from './Links.style'
import { Grid, Hidden, Typography } from '@material-ui/core'
import React, { memo } from 'react'

import EULogo from '~/images/EU_Logo.png'
import { Institution } from '~/types/institution'
import Institutions from '~/components/Navigation/Institutions'
import { MoreHoriz } from '@material-ui/icons'
import NavItem from '~/components/NavItem'
import { contentPadding } from '~/styles/sizes'

type ViewProps = {
    location: Location
    isExpandable: boolean
    isExpanded: boolean
    setIsExpanded(isExpanded: boolean): void
    isScrolled: boolean
    institutions: Institution[]
}

export default memo(
    ({
        location,
        isExpandable,
        isExpanded,
        setIsExpanded,
        isScrolled,
        institutions,
    }: ViewProps) => {
        const isUnfilteredFeed = location.pathname.replace(new RegExp('/', 'g'), '') === 'feed'
        const isFilteredFeed = location.pathname.includes('feed') && !isUnfilteredFeed
        const isFeed = isFilteredFeed || isUnfilteredFeed
        const isAbout = location.pathname.includes('about')
        const isTransparent = (isUnfilteredFeed && !isScrolled) || isAbout
        const isInstitutionsVisible = isFilteredFeed || (isUnfilteredFeed && isScrolled)

        return (
            <ExpansionPanel expanded={isExpanded} isTransparent={isTransparent}>
                <TitleContainer
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="flex-start"
                >
                    <Grid item>
                        <TitleRow variant="body1">
                            <NavItem to="/feed">
                                <HomeLink component="span">
                                    MOVING BORDERS&nbsp;&nbsp;&nbsp;
                                </HomeLink>
                            </NavItem>
                            <Hidden smDown>
                                <NavItem to="/feed" partiallyActive={true}>
                                    Feed
                                </NavItem>
                                , <NavItem to="/about">About</NavItem>,{' '}
                                <NavItem to="/contact">Contact</NavItem>
                            </Hidden>
                        </TitleRow>
                    </Grid>
                    <Grid item>
                        {isExpandable && (
                            <ExpandButton
                                onClick={() => setIsExpanded(!isExpanded)}
                                aria-label="Expand Menu"
                            >
                                <MoreHoriz />
                            </ExpandButton>
                        )}
                        {!isExpandable && (
                            <FundingLogo
                                src={EULogo}
                                title="Co-funded by the Creative Europe Programme of the EU"
                                alt="Co-funded by the Creative Europe Programme of the EU"
                            />
                        )}
                    </Grid>
                </TitleContainer>
                <ExpandingLinks>
                    <TopLevelNavBox>
                        <Grid container direction="column">
                            <Hidden mdUp>
                                <Grid item>
                                    <MobilePageNav>
                                        <Typography variant="body1">
                                            <NavItem to="/feed" partiallyActive={true}>
                                                Feed
                                            </NavItem>
                                            , <NavItem to="/about">About</NavItem>,{' '}
                                            <NavItem to="/contact">Contact</NavItem>
                                        </Typography>
                                    </MobilePageNav>
                                </Grid>
                            </Hidden>
                            {isFeed && (
                                <Grid item>
                                    <Hidden mdUp>
                                        <Institutions institutions={institutions} />
                                    </Hidden>
                                    <Hidden smDown>
                                        <InstitutionsHideShow isVisible={isInstitutionsVisible}>
                                            <Institutions institutions={institutions} />
                                        </InstitutionsHideShow>
                                    </Hidden>
                                </Grid>
                            )}
                        </Grid>
                    </TopLevelNavBox>
                </ExpandingLinks>
            </ExpansionPanel>
        )
    }
)
